/**
 * Identity shared by the suggestion panel, the hook that drives it and the
 * input that points at it through `aria-controls` / `aria-activedescendant`.
 * They live apart from the component so the panel module exports components
 * only.
 */
export const ATLAS_SUGGESTIONS_ID = "atlas-suggestions";

export const ATLAS_SUGGESTIONS_LABEL = "Suggestions for your store";

export const atlasSuggestionOptionId = (index: number) =>
  `${ATLAS_SUGGESTIONS_ID}-option-${index}`;
